import styled from 'styled-components';
import section4Background from '../../assets/images/section4_background.png';
import externalAd from '../../assets/icons/svg/external_ad.svg';
import outdoorAd from '../../assets/icons/svg/outdoor_ad.svg';
import arrowRedIcon from '../../assets/icons/svg/arrow_red.svg';
import tv from '../../assets/images/tv.png';
import tvInside from '../../assets/gif/section4.gif';

const ACCENT = '#ff2828';
const BORDER = '#e5e7eb';
const TEXT = '#111827';
const MUTED = '#6b7280';

const Section4Container = styled.section`
  position: relative;
  display: flex;
  justify-content: center;
  width: 100%;
  background: #ffffff;
  padding: 96px 0;
  overflow: hidden;

  @media (max-width: 768px) {
    padding: 56px 0;
  }
`;

/* 우상단 장식 배경 – 과하지 않게 흐리게 */
const BackgroundImage = styled.img`
  position: absolute;
  top: -60px;
  right: -60px;
  width: 560px;
  opacity: 0.12;
  pointer-events: none;
  user-select: none;

  @media (max-width: 768px) {
    width: 260px;
    top: -30px;
    right: -30px;
  }
`;

const Inner = styled.div`
  width: 100%;
  max-width: 1200px;
  padding: 0 24px;
  display: flex;
  flex-direction: column;
  gap: 48px;

  @media (max-width: 768px) {
    padding: 0 16px;
    gap: 28px;
  }
`;

const Title = styled.h2`
  font-size: 40px;
  font-weight: 800;
  color: ${TEXT};
  text-align: center;
  letter-spacing: -0.4px;

  @media (max-width: 768px) {
    font-size: 22px;
  }
`;

/* 상단 카드 2개 */
const ContentTopContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  justify-content: center;
`;

const TopCard = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 18px 20px;
  border: 1px solid ${BORDER};
  border-radius: 20px;
  background: #fff;
  min-width: 280px;
  flex: 1 1 360px;
  max-width: 520px;
  box-shadow: 0 10px 28px rgba(17, 24, 39, 0.06);
`;

const CardIcon = styled.div`
  width: 72px;
  height: 72px;
  border-radius: 999px;
  background: #fff5f5;
  display: grid;
  place-items: center;

  img { width: 36px; height: 36px; }
`;

const CardText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;

  span {
    font-size: 16px;
    color: #374151;
  }
  h3 {
    font-size: 22px;
    font-weight: 800;
    color: ${TEXT};
  }

  @media (max-width: 768px) {
    span { font-size: 14px; }
    h3 { font-size: 18px; }
  }
`;

/* 하단 TV + 설명 */
const ContentBottom = styled.div`
  display: grid;
  gap: 12px;
  justify-items: center;
`;

const TvWrapper = styled.div`
  position: relative;
  width: 100%;
  max-width: 980px;
  aspect-ratio: 1012 / 616; /* 원본 TV 비율 */
  margin: 0 auto;
`;

const TvImg = styled.img`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
`;

/* 내부 GIF를 %로 배치 – TV 베젤 따라 자동 스케일 */
const TvInsideImg = styled.img`
  position: absolute;
  /* 원본 기준: width 974/1012, height 544/616, top 8/616, left 19/1012 */
  width: 96.2%;
  height: 88.3%;
  top: 1.3%;
  left: 1.88%;
  border-radius: 12px;
  object-fit: contain;
  box-shadow: inset 0 0 0 1px rgba(17,24,39,0.06);
`;

const TvDescription = styled.p`
  text-align: center;
  color: #222;
  font-size: 16px;
  font-weight: 800;
  line-height: 1.6;
  margin: 0;

  @media (max-width: 768px) {
    font-size: 13px;
    line-height: 1.5;
  }
`;

/* 좌우 화살표 – 데스크탑만 살짝 보이게, % 위치 */
const Arrow = styled.img`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 28px;
  opacity: 0.85;

  @media (max-width: 768px) {
    display: none;
  }
`;

const LeftArrow = styled(Arrow)`
  left: -36px;
`;
const RightArrow = styled(Arrow)`
  right: -36px;
  transform: translateY(-50%) scaleX(-1);
`;

function Section4() {
  return (
      <Section4Container>
        <BackgroundImage src={section4Background} alt="section4_background" />
        <Inner>
          <Title>디지털사이니지 디스플레이 방식</Title>

          <ContentTopContainer>
            <TopCard>
              <CardIcon>
                <img src={externalAd} alt="외부광고 아이콘" />
              </CardIcon>
              <CardText>
                <span>광고를 원하는 고객의</span>
                <h3>외부광고</h3>
              </CardText>
            </TopCard>

            <TopCard>
              <CardIcon>
                <img src={outdoorAd} alt="매물광고 아이콘" />
              </CardIcon>
              <CardText>
                <span>부동산중개소의</span>
                <h3>매물광고</h3>
              </CardText>
            </TopCard>
          </ContentTopContainer>

          <ContentBottom>
            <TvWrapper>
              <TvImg src={tv} alt="TV 프레임" />
              <TvInsideImg src={tvInside} alt="디지털사이니지 재생 화면" />

              {/* 데스크탑에서만 좌우 힌트 */}
              <LeftArrow src={arrowRedIcon} alt="왼쪽 화살표" />
              <RightArrow src={arrowRedIcon} alt="오른쪽 화살표" />
            </TvWrapper>

            <TvDescription>
              외부광고 및 매물광고가 각각 전면, 2면, 6면에 순차 반복적으로 노출됩니다.
              <br />
              외부광고(전면·2면·6면) → 매물광고(전면·2면·6면) → 외부광고 → 매물광고
            </TvDescription>
          </ContentBottom>
        </Inner>
      </Section4Container>
  );
}

export default Section4;
